import { createStore } from "zustand";

import type { RenewType } from "@/models/PatientRenewalInfoModel.ts";
import { makeZustandContextStore } from "@/utils/zustandUtils.tsx";

export type PatientListRenewalData =
  | {
      patientId: string;
      renewalType: RenewType;
    }
  | {
      patientId?: undefined;
      renewalType?: undefined;
    };

export type PatientListRenewalState = PatientListRenewalData & {
  openRenewal: (patientId: string, renewalType: RenewType) => void;
  closeRenewal: () => void;
};

const createPatientListRenewalStore = (initProps: PatientListRenewalData) => {
  return createStore<PatientListRenewalState>()(set => ({
    ...initProps,
    openRenewal: (patientId: string, renewalType: RenewType) => set({ patientId, renewalType }),
    closeRenewal: () => set({ patientId: undefined, renewalType: undefined }),
  }));
};

export const [, PatientListRenewalProvider, usePatientListRenewal] = makeZustandContextStore<
  PatientListRenewalData,
  PatientListRenewalState
>("PatientListRenewal", createPatientListRenewalStore);
